<div #carouselContainer class="carousel-container" [class.without-side-nav]="isSideNavHidden">
    @if (isOverflowing) {
        <button
            type="button"
            class="nav-btn nav-btn-left"
            (click)="scrollItemLeft()"
            [disabled]="!canScrollLeft"
            aria-label="Scroll left"
        >&#8249;</button>
    }

    <div #filtersViewport class="filters-viewport" (wheel)="onMouseWheel($event)">
        <div class="filters-row">
            @for (filter of filters; track filter.id) {
                <div class="filter-item">
                    <app-dashboard-custom-filter
                        [filterName]="filter.name"
                        [NoOfRecords]="filter.count"
                        [filterId]="filter.id"
                        [checked]="filter.checked"
                        (valueEmitted)="onFilterClick($event)"
                    ></app-dashboard-custom-filter>
                </div>
            }
        </div>
    </div>

    @if (isOverflowing) {
        <button
            type="button"
            class="nav-btn nav-btn-right"
            (click)="scrollItemRight()"
            [disabled]="!canScrollRight"
            aria-label="Scroll right"
        >&#8250;</button>
    }
</div>

<div class="selected-filters-count" [class.with-arrows]="isOverflowing">
    @if (selectedCount > 0) {
        <span>
            {{ selectedCount }}
            {{ selectedCount === 1 ? 'Filter' : 'Filters' }}
            Selected
        </span>
    } @else {
        <span>Showing All Cases</span>
    }
</div>